import { message } from "antd";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { postNewCategory } from "../../../helpers/api";
import _ from "lodash";
import { RequiredIndicator } from "../../../components";
import smallTalk from "smalltalk";
import { getUser } from "../../../helpers/auth";

export default function NewCategoryForm({ onSuccess }) {
  const { handleSubmit, register, reset, watch } = useForm();

  const { mutateAsync, isLoading } = useMutation(
    (data) => postNewCategory(data),
    {
      onSuccess: (data, variables, context) => {
        if (data.status === 201) {
          message.success("Category created successfully!");
          reset();
          onSuccess();
          return;
        }

        throw data;
      },
      onError: (error, variables, context) => {
        const err = error.response?.data?.message;
        if (_.isArray(err)) {
          err.map((err) => message.error(err.message));
        } else {
          message.error(err || "Error creating category");
        }
      },
      retry: true,
    }
  );

  const postSubmit = (data) => {
    smallTalk
      .confirm("Add Category", "You are about to add a category. Continue?", {
        buttons: {
          ok: "YES",
          cancel: "NO",
        },
      })
      .then(() => mutateAsync(data))
      .catch((ex) => message.error("no action taken"));
  };

  return (
    <form onSubmit={handleSubmit(postSubmit)}>
      <div className="field">
        <label htmlFor="title">
          Title
          <RequiredIndicator />
        </label>
        <input
          type="text"
          id="title"
          autoFocus
          {...register("title", { required: true })}
          className="input w-100"
          placeholder="Enter category title"
        />
      </div>

      <div className="field">
        <label htmlFor="type">
          Type
          <RequiredIndicator />
        </label>
        <select
          id="type"
          {...register("type", { required: true })}
          className="input w-100">
          <option value="">Select category type</option>
          <option value="expense">Expense</option>
          {/* <option value="income">Income</option> */}
          <option value="service">Service</option>
          {/* <option value="support">Support</option> */}
        </select>
      </div>

      <div className="field">
        <label htmlFor="description">Description</label>
        <textarea
          id="description"
          {...register("description")}
          className="textarea w-100"
          rows={4}
          placeholder="Enter category description"></textarea>
      </div>

      <div className="field mt-4">
        <button
          type="submit"
          className="button app-btn btn-prim w-100 p-2"
          disabled={isLoading}>
          {isLoading ? "Creating..." : "Add Category"}
        </button>
      </div>
    </form>
  );
}
